export function samlSpMetadataPath(prefix: string, providerId: string): string {
  return `${prefix}/saml2/sp/metadata?providerId=${encodeURIComponent(providerId)}`;
}

export function samlSpAcsPath(prefix: string, providerId: string): string {
  return `${prefix}/saml2/sp/acs/${encodeURIComponent(providerId)}`;
}

export function oidcCallbackPath(prefix: string, providerId: string): string {
  return `${prefix}/callback/${encodeURIComponent(providerId)}`;
}
